// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { MultipleChoice } from './FormFields';
import type { AddressFormInput } from '../../models/AddressForm';
import type { FieldErrors } from '../../types/form';
import Button from './Button';
import TextInput from './TextInput';
import Text from './Typography';

type Props = {
  address: AddressFormInput,
  errors: FieldErrors,
  submitForm?: (Event) => void,
  onAnswerChange: (number, []|string) => void,
  savedResponses: any[],
  parentQuestions: any[],
  isLoading: boolean,
  isLast: boolean,
  question: string
} & WithTranslation

type State = {
  answers: any[]
}

class SurveyQuestion extends Component<Props, State> {
  state: State = {
    answers: []
  }

  componentWillMount() {
    this.setInitialAnswers(this.props);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.savedResponses !== this.props.savedResponses || nextProps.question !== this.props.question) {
      this.setInitialAnswers(nextProps);
    }
  }

  setInitialAnswers = (props: Props) => {
    if (props.savedResponses && Array.isArray(props.savedResponses)) {
      props.savedResponses.map((response) => {
        if (response.question_id === props.question.id) {
          let newAnswers;
          if (response.text) {
            newAnswers = response.text;
          } else {
            const existing = response.answers;
            const responses = [];
            existing.map((answer) => {
              responses.push(answer.id);
              return null;
            });
            newAnswers = responses;
          }
          this.setState({
            answers: newAnswers
          });
          this.props.onAnswerChange(props.question.id, newAnswers);
        }
        return null;
      });
    }
  }

  props: Props;

  toggleRadio = (optionId: number) => {
    const answerId = parseInt(optionId, 10);
    const answers = [];
    answers.push(answerId);

    this.setState({ answers });
    this.props.onAnswerChange(this.props.question.id, answers);

    const selectedAnswer = this.props.question.answers.find((answer) => answer.id === optionId);
    if (selectedAnswer && selectedAnswer.questions.length === 0) {
      // submit form if no followup questions
      this.props.submitForm(document.createEvent('Event')); // mock event
    }
  }

  changeText = (e: SyntheticInputEvent) => {
    this.setState({
      answers: e.target.value
    });
    this.props.onAnswerChange(this.props.question.id, e.target.value);
  }


  toggleCheckbox = (answers: []) => {
    this.setState({
      answers
    });
    this.props.onAnswerChange(this.props.question.id, answers);
  }

  render() {
    const { question, parentQuestions = [], t } = this.props;
    let subtitleText = '';
    if (question.multiple_choice) {
      subtitleText = t('select_all');
    }
    if (!question.multiple_choice && !question.custom && question.answers > 2) {
      subtitleText = t('choose_one');
    }
    return (
      <div className={`question ${parentQuestions.length === 0 ? 'is-root' : 'is-child is-nested-field'}`}>
        {parentQuestions.length === 0 ? (
          <Text h1 align='center'>{question.text}</Text>
        ) : (
          <Text h3 align='center' className='is-centered'>{question.text}</Text>
        )}
        {subtitleText ? (
          <Text paragraph align='center' className='is-subtitle'>{subtitleText}</Text>
        ) : '' }
        <div className={`${parentQuestions.length === 0 ? 'onboarding__questionnaire' : ''}`}>
          { !question.answers ? (
            <TextInput
              name={question.id}
              onChange={this.changeText}
              value={this.state.answers}
              label={t('your_answer')}
              focusOnMount
            />
          ) : (
            <MultipleChoice
              parentQuestions={parentQuestions}
              question={question}
              onChange={question.multiple_choice ? this.toggleCheckbox : this.toggleRadio}
              answers={this.state.answers}
              isShown
              isRequired
            />
          )}
          {Array.isArray(this.state.answers) ? this.state.answers.map((id) => {
            const selectedAnswer = question.answers.find((a) => id === a.id);
            if (selectedAnswer && selectedAnswer.questions) {
              return selectedAnswer.questions.map((q) => (
                <SurveyQuestion
                  question={q}
                  onAnswerChange={this.props.onAnswerChange}
                  savedResponses={this.props.savedResponses}
                  parentQuestions={this.props.parentQuestions.concat([question.id])}
                />
              ));
            }
            return '';
          }) : ''}
          {(question.multiple_choice || question.custom) ? (
            <Button
              className='is-primary is-sequential'
              label={`${this.props.isLast ? t('submit_questionnaire') : t('next')}`}
              formButton
              id={`${this.props.isLast ? 'submit' : 'next'}`}
              isLoading={this.props.isLoading}
            />
          ) : '' /* as per designs, radio buttons contain their own submit function */ }
        </div>
      </div>
    );
  }
}

SurveyQuestion.defaultProps = {
  submitForm: null
};

export default withTranslation('question')(SurveyQuestion);



// WEBPACK FOOTER //
// ./src/components/shared/Question.js